/**
 * `Card` — a 1px-border surface container. Used for every form card
 * + table card in the admin (accounts table, account-detail edit,
 * billing card). Thin border + small radius matches CLAUDE.md §4.
 *
 * Forwards arbitrary DOM props (onClick, role, tabIndex, onKeyDown,
 * onMouse*, aria-*, …) to the root <div> so a Card can be made
 * interactive — without this, an `onClick` spread onto <Card> is
 * silently dropped (the churn-risk drill-down trigger hit exactly that).
 */

import type { CSSProperties, HTMLAttributes, ReactNode } from 'react';

import { useC } from '../../lib/theme.js';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  style?: CSSProperties;
  className?: string;
}

export function Card({
  children,
  style,
  className,
  ...rest
}: CardProps): JSX.Element {
  const C = useC();
  return (
    <div
      className={className}
      style={{
        background: C.surface,
        border: `1px solid ${C.border}`,
        borderRadius: 3,
        ...style,
      }}
      {...rest}
    >
      {children}
    </div>
  );
}
